import axios from './axiosConfig';

const api = {
    // 登录
    login: (un, pw) => axios.post('/login', { username: un, password: pw }),
    // 注册
    regist: (un, pw) => axios.post('/regist', { username: un, password: pw }),
    // 退出登录
    logout: () => axios.post('/logout'),
    // 获取RSA公钥
    getRSAPublicKey: () => axios.get('/system/getRSAPublicKey'),
    // 获取当前版本
    getVersion: () => axios.post('/system/getSystemVersion'),
    // 登录（RSA）
    loginByRSA: (un, pw) => axios.post('/loginByRSA', { username: un, password: pw })
};
export default api;
